//@flow

import * as React from "react";
import { CRISP_WEBSITE_ID } from "../../config";
import { getUserEmail } from "../../Library/UserInfo";

type Props = {||};

const MAX_IDENTIFY_ATTEMPTS = 15;

let hasRequestedInitialClose = false;
let hasRegisteredReadyClose = false;

function isValidEmailForCrisp(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
}

class CrispChat extends React.Component<Props> {
  _email: string;
  _identifyAttempts: number;
  _identifyInterval: ?IntervalID;

  componentDidMount() {
    this._identifyAttempts = 0;
    this._loadCrisp();
    if (!this._identifyUser()) {
      this._identifyInterval = setInterval(this._identifyUser, 1000);
    }
  }

  componentWillUnmount() {
    this._stopIdentifyingUser();
  }

  _stopIdentifyingUser = () => {
    if (this._identifyInterval) {
      clearInterval(this._identifyInterval);
      this._identifyInterval = null;
    }
  };

  _loadCrisp = () => {
    const windowRef = (window: any);
    windowRef.$crisp = windowRef.$crisp || [];
    windowRef.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
    this._closeInitially();
    this._closeWhenReady(windowRef);

    if (document.getElementById("crisp-chat-loader")) {
      return;
    }

    const script = document.createElement("script");
    script.id = "crisp-chat-loader";
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  _closeInitially = () => {
    if (hasRequestedInitialClose) {
      return;
    }

    this._closeChat();
    hasRequestedInitialClose = true;
  };

  _closeChat = () => {
    const crisp = (window: any).$crisp;
    if (crisp && crisp.push) {
      crisp.push(["do", "chat:close"]);
    }
  };

  _closeWhenReady = (windowRef: any) => {
    if (hasRegisteredReadyClose) {
      return;
    }

    const existingReadyTrigger = windowRef.CRISP_READY_TRIGGER;
    windowRef.CRISP_READY_TRIGGER = () => {
      if (existingReadyTrigger) {
        existingReadyTrigger();
      }
      this._closeChat();
    };
    hasRegisteredReadyClose = true;
  };

  _identifyUser = (): boolean => {
    debugger;
    this._identifyAttempts += 1;
    const email = getUserEmail();

    if (!email) {
      if (this._identifyAttempts >= MAX_IDENTIFY_ATTEMPTS) {
        this._stopIdentifyingUser();
        return true;
      }
      return false;
    }

    if (!isValidEmailForCrisp(email) || email === this._email) {
      this._stopIdentifyingUser();
      return true;
    }

    const crisp = (window: any).$crisp;
    if (crisp && crisp.push) {
      crisp.push(["set", "user:email", [email]]);
      this._email = email;
      this._stopIdentifyingUser();
      return true;
    }

    return false;
  };

  render() {
    return null;
  }
}

export default CrispChat;
